export const LOAD_USAGE_PLANS = 'LOAD_USAGE_PLANS'
export const LOADING_USAGE_PLANS = 'LOADING_USAGE_PLANS'
export const LOAD_USAGE_PLANS_SUCCEEDED = 'LOAD_USAGE_PLANS_SUCCEEDED'
export const LOAD_USAGE_PLANS_FAILED = 'LOAD_USAGE_PLANS_FAILED'


export function loadUsagePlans() {
    return { type: LOAD_USAGE_PLANS }
}
